export default "__VITE_ASSET__h5y5hn2B__"